export default "__VITE_PUBLIC_ASSET__1ca95ff9__"